import { sbEditable } from '@storyblok/storyblok-editable';
import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import styles from './DescriptionList.module.scss';
import { setupTransitionInTimeline } from './DescriptionList.transitions';
import type { DescriptionListProps, DescriptionListRef } from './DescriptionList.data';
import { useScrollTransition } from 'util/react-transition-component';
import DescriptionListItem from './description-list-item/DescriptionListItem';
import Heading from 'components/atoms/heading/Heading';

export default function DescriptionList({
  blok,
  ref,
  ...props
}: DescriptionListProps & { ref?: Ref<DescriptionListRef> }): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  useScrollTransition({
    scroll: {
      trigger: elementRef,
      vars: {},
    },
    setupOptions: () => ({
      refs: {
        elementRef,
      },
      setupTransitionInTimeline,
    }),
  });

  return (
    <div
      ref={elementRef}
      className={classNames(styles.descriptionList, props.className)}
      {...sbEditable(blok)}
    >
      {blok.title && (
        <Heading
          className={styles.title}
          as="h2"
          size="heading-03"
          transitionInType="splitCharsSlideInUp"
          disableTriggerInOnScroll={false}
        >
          {blok.title.split('\n').map((line, index) => (
            <div key={`${line}-${index}`}>{line}</div>
          ))}
        </Heading>
      )}

      {blok.list.map((item, index) => (
        <DescriptionListItem
          blok={item}
          key={item._uid}
          index={index}
          className={classNames(styles.item)}
        />
      ))}
    </div>
  );
}
